import React, { useState, useEffect } from 'react';
import { Container, MainTitle, Title, Body } from './style';
import MapY from '../../Map/MapModal';
import ImageBlock from './ImageGallery';
import { useShowModal } from '../../../hooks';
import Description from './Description';
import CardTitle from './CardMainTitle/index';

import WorkFooter from './WorkFooter';

const TaskCard = ({
  data = {},
  medium,
  titleLeft,
  canDeleteImage,
  handleDeleteImage,
  handleDescription,
  errorHelper,
  description,
  allowEdit,
  objectsList,
  borderLess,
  printTo,
}) => {
  const { showBlured } = useShowModal();
  // const { role } = useSelector((state) => state.authReducer);
  const [mainImage, setMainImage] = useState({});
  const [geoLocation, setGeoLocation] = useState([]);

  // const obJectHandler = () => {
  //   if (objectsList?.length > 0 && !!data?.objects) {
  //     const subObjId = data?.objects[0]?._id ?? data?.objects[0];
  //     const matchedData = objectsList.find((item) => item?._id === subObjId);
  //     return matchedData;
  //   }
  //   if (!objectsList?.length && data?.objects) {
  //     return data?.objects[0];
  //   }
  // };
  useEffect(() => {
    if (
      data?.media !== undefined &&
      data?.media !== null &&
      data?.media?.length > 0
    ) {
      const latLng = [data?.media[0]?.lat, data?.media[0]?.lng];
      if (latLng !== undefined && latLng !== null) {
        setGeoLocation([data?.media[0]?.lat, data?.media[0]?.lng]);
        setMainImage(data?.media && data?.media[0]);
      }
    }
  }, [data]);

  const handleShowModal = () => {
    showBlured({
      title: 'Тадбир ўтказилган жой',
      maxWidth: '1200px',
      height: '600px',
      withHeader: false,
      body: () => <MapY latLang={geoLocation} />,
    });
  };

  const checkActive = (image) => {
    if (image === mainImage?.image) return true;
  };

  const handleMainImage = (image) => {
    const latLng = [image?.lat, image?.lng];
    setGeoLocation(latLng);
    setMainImage(image);
  };

  return (
    <Container medium={medium} borderLess={borderLess}>
      <MainTitle titleLeft={titleLeft}>
        <Title titleLeft={titleLeft}>
          <CardTitle data={data} />
        </Title>
      </MainTitle>
      <Body medium={medium}>
        <ImageBlock
          medium={medium}
          imageData={data}
          checkActive={checkActive}
          handleMainImage={handleMainImage}
          mainImage={mainImage}
          canDeleteImage={canDeleteImage}
          deleteImage={handleDeleteImage}
        />
        <WorkFooter
          borderB
          data={data}
          disabledCheckbox
          handleShowModal={handleShowModal}
          // objectsList={obJectHandler()}
          printTo={printTo}
        />
      </Body>
      <Description
        allowEdit={allowEdit}
        handleShowModal={handleShowModal}
        mainworkData={data.desc}
        medium={medium}
        workId={data._id}
        title={data?.subCategoryName}
        value={description}
        onChange={handleDescription}
        errorHelper={errorHelper}
      />
    </Container>
  );
};

export default React.memo(TaskCard);
